import React from 'react';

import { Text } from '../../common/Text';

type SubLabelProps = {
  title: string;
};

export function SubLabel({ title }: SubLabelProps) {
  return (
    <Text className="text-foreground" style={{ fontSize: 13, marginBottom: 3 }}>
      {title}
    </Text>
  );
}
